// extracted by mini-css-extract-plugin
module.exports = {"root":"az_Ul","marginNormal":"az_Vl","marginDense":"az_Wl","fullWidth":"az_Xl"};